import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Classe from "../classes/Classe";
import StudentLine from "../students/StudentLine";
import Listprint from "../../Listprint";
import SectionclasseForm from "./SectionclasseForm";
class Sectionclasse extends Component {
    state = {
        isModal: false, loading: true, formData: "", sections: [],
        data: {
            columns: [
                { label: "Classe", field: "classe", sort: "asc", width: 150 },
                { label: "Section", field: "section", sort: "asc", width: 150 },
                { label: "Élèves", field: "student", sort: "asc", width: 80 },
                { label: "Opération", field: "operation", sort: "asc", width: 80 },
                { label: "Date", field: "updated_at", sort: "asc", width: 100 },
            ], rows: [],
        },
    };

    componentDidMount() { this.getSections(); this.getUpdated(); }

    getSections = async () => {
        this.setState({ loading: true });
        try {
            const response = await axios.get("sections");
            this.setState({ sections: Array.isArray(response.data) ? response.data : [] });
        } catch (error) {
            toast.error("Impossible de charger les classes.");
        } finally {
            this.setState({ loading: false });
        }
    };

    getUpdated = async () => {
        try {
            const response = await axios.get("sectionclasses/operation/operation");
            const rows = (Array.isArray(response.data) ? response.data : []).map((item) => ({
                classe: `${item.class?.short_entitled_class || ""} ${item.title || ""}`.trim(),
                section: item.section?.short_entitled_section || "—",
                student: item.students?.length || 0,
                operation: <span className={`sectionclasse-operation ${item.operation === "Supprimer" ? "is-danger" : ""}`}>{item.operation}</span>,
                updated_at: <span className="sectionclasse-date">{item.updatedAt ? new Intl.DateTimeFormat("fr-FR").format(new Date(item.updatedAt)) : "—"}</span>,
            }));
            this.setState((state) => ({ data: { columns: state.data.columns, rows } }));
        } catch (error) {
            this.setState((state) => ({ data: { columns: state.data.columns, rows: [] } }));
        }
    };

    showModal = (sectionclasse = null) => {
        this.setState((state) => ({ isModal: !state.isModal, formData: sectionclasse }), () => {
            if (!this.state.isModal) { this.getSections(); this.getUpdated(); }
        });
    };

    delete = async (id) => {
        if (!window.confirm("Supprimer définitivement cette classe ?")) return;
        try {
            const response = await axios.delete(`sectionclasses/${id}`);
            toast.success(response?.data?.msg || "La classe a été supprimée.");
            this.getSections();
            this.getUpdated();
        } catch (error) {
            toast.error(error.response?.data?.msg || "La suppression a échoué.");
        }
    };

    handleCheck = (permission) => {
        try {
            const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
            return permissions.some((item) => permission === item.permission);
        } catch (error) { return false; }
    };

    renderClassCard = (item, section) => {
        const students = item.students?.length || 0;
        const name = `${item.class?.short_entitled_class || ""} ${item.title || ""}`.trim();
        return (
            <div className="col-sm-6 col-xl-4" key={item.id}>
                <article className="sectionclasse-class-card">
                    <div className="sectionclasse-class-card__top">
                        <span className="sectionclasse-class-card__icon"><FeatherIcon icon="book-open" size={18} /></span>
                        <span className="sectionclasse-class-card__section">{section.short_entitled_section}</span>
                    </div>
                    <h3>{name || "Classe sans nom"}</h3>
                    <div className="sectionclasse-class-card__meta">
                        <span><FeatherIcon icon="users" size={15} /><strong>{students}</strong> élève{students > 1 ? "s" : ""}</span>
                        <span className="sectionclasse-status"><i />{item.status || "Active"}</span>
                    </div>
                    {(this.handleCheck("Modifier classe") || this.handleCheck("Supprimer classe")) && (
                        <div className="sectionclasse-class-card__actions">
                            {this.handleCheck("Modifier classe") && <button type="button" onClick={() => this.showModal(item)} className="sectionclasse-icon-button" title="Modifier cette classe" aria-label={`Modifier ${name}`}><FeatherIcon icon="edit-3" size={15} /></button>}
                            {this.handleCheck("Supprimer classe") && <button type="button" onClick={() => this.delete(item.id)} className="sectionclasse-icon-button is-danger" title="Supprimer cette classe" aria-label={`Supprimer ${name}`}><FeatherIcon icon="trash-2" size={15} /></button>}
                        </div>
                    )}
                </article>
            </div>
        );
    };

    render() {
        const activeSections = this.state.sections.map((section) => ({
            ...section,
            sectionclasses: [...(section.sectionclasses || [])]
                .filter((item) => item.operation !== "Supprimer")
                .sort((a, b) => (a.class?.short_entitled_class || "").localeCompare(b.class?.short_entitled_class || "", "fr", { numeric: true })),
        }));
        const allClasses = activeSections.flatMap((section) => section.sectionclasses.map((item) => ({ section, item })));
        const labels = allClasses.map(({ section, item }) => `${item.class?.short_entitled_class || ""} ${item.title || ""} ${section.short_entitled_section || ""}`.trim());
        const chartData = allClasses.map(({ item }) => item.students?.length || 0);
        const totalStudents = chartData.reduce((total, count) => total + count, 0);

        return (
            <main className="container sectionclasse-page">
                <Helmet><title>{process.env.REACT_APP_NAME} | Classes</title></Helmet>
                <header className="sectionclasse-hero">
                    <span className="sectionclasse-hero__dots" aria-hidden="true" />
                    <div className="sectionclasse-hero__content">
                        <span className="sectionclasse-eyebrow"><FeatherIcon icon="bookmark" size={14} />Organisation pédagogique</span>
                        <h1>Le registre des classes</h1>
                        <p>Une vue claire de vos sections, de vos classes et de leurs effectifs.</p>
                        <div className="sectionclasse-hero__footer">
                            <div className="sectionclasse-stats" aria-label="Résumé des classes">
                                <span><strong>{allClasses.length}</strong>Classes</span>
                                <span><strong>{totalStudents}</strong>Élèves</span>
                                <span><strong>{activeSections.length}</strong>Sections</span>
                            </div>
                            <div className="sectionclasse-hero__actions">
                                <Link to="/manuel#classes" className="sectionclasse-guide-button" title="Consulter la documentation du registre des classes"><FeatherIcon icon="book-open" size={17} />Documentation</Link>
                                {this.handleCheck("Ajouter classe") && <button type="button" className="sectionclasse-add-button" onClick={() => this.showModal(null)}><FeatherIcon icon="plus" size={17} />Nouvelle classe</button>}
                            </div>
                        </div>
                    </div>
                    <div className="sectionclasse-book" aria-hidden="true">
                        <div className="sectionclasse-book__page is-left"><span>CHAPITRE</span><strong>Classes</strong><i /><i /><i /></div>
                        <div className="sectionclasse-book__spine" />
                        <div className="sectionclasse-book__page is-right"><FeatherIcon icon="users" size={25} /><strong>{totalStudents}</strong><small>élèves inscrits</small><b /></div>
                    </div>
                </header>

                <div className="row g-4 sectionclasse-layout">
                    <div className="col-lg-8">
                        <section className="sectionclasse-panel sectionclasse-chart-panel">
                            <div className="sectionclasse-panel__heading">
                                <span className="sectionclasse-panel__icon"><FeatherIcon icon="bar-chart-2" size={18} /></span>
                                <div><span>Vue d’ensemble</span><h2>Effectif par classe</h2></div>
                            </div>
                            {labels.length ? <StudentLine labels={labels} data={chartData} title="Les élèves par classe" /> : <div className="sectionclasse-empty is-compact"><FeatherIcon icon="bar-chart" size={24} />Les effectifs apparaîtront ici.</div>}
                        </section>

                        <section className="sectionclasse-directory">
                            <div className="sectionclasse-directory__heading">
                                <div><span>Répertoire</span><h2>Classes par section</h2></div>
                                <em>{allClasses.length} au total</em>
                            </div>
                            {this.state.loading ? <div className="sectionclasse-loader"><FeatherIcon className="user-search-spin" icon="loader" /></div> : activeSections.length ? activeSections.map((section) => (
                                <div className="sectionclasse-section" key={section.id}>
                                    <div className="sectionclasse-section__heading">
                                        <div className="sectionclasse-section__letter">{(section.short_entitled_section || section.entitled_section || "S").charAt(0)}</div>
                                        <div><span>Section</span><h3>{section.entitled_section} <small>{section.short_entitled_section}</small></h3></div>
                                        <em>{section.sectionclasses.length} classe{section.sectionclasses.length > 1 ? "s" : ""}</em>
                                    </div>
                                    {section.sectionclasses.length ? <div className="row g-3">{section.sectionclasses.map((item) => this.renderClassCard(item, section))}</div> : <div className="sectionclasse-empty is-inline">Aucune classe active dans cette section.</div>}
                                </div>
                            )) : <div className="sectionclasse-empty"><span><FeatherIcon icon="book-open" size={28} /></span><h3>Le registre est encore vide</h3><p>Ajoutez une première classe pour commencer à organiser vos élèves.</p></div>}
                        </section>
                    </div>
                    <aside className="col-lg-4">
                        {this.handleCheck("Afficher classe") && (
                            <section className="sectionclasse-panel sectionclasse-side-panel">
                                <div className="sectionclasse-panel__heading">
                                    <span className="sectionclasse-panel__icon is-warm"><FeatherIcon icon="layers" size={18} /></span>
                                    <div><span>Configuration</span><h2>Niveaux de classe</h2></div>
                                </div>
                                <Classe />
                            </section>
                        )}
                        <section className="sectionclasse-panel sectionclasse-side-panel">
                            <div className="sectionclasse-panel__heading">
                                <span className="sectionclasse-panel__icon is-warm"><FeatherIcon icon="clock" size={18} /></span>
                                <div><span>Journal</span><h2>Dernières opérations</h2></div>
                            </div>
                            {this.state.data.rows.length ? (
                                <Listprint columns={this.state.data.columns} rows={this.state.data.rows} title="Dernières opérations sur les classes" classe="Toutes les classes" />
                            ) : <div className="sectionclasse-empty is-compact"><FeatherIcon icon="inbox" size={22} />Aucune opération récente.</div>}
                        </section>
                    </aside>
                </div>
                <SectionclasseForm isModal={this.state.isModal} formData={this.state.formData} showModal={this.showModal} />
            </main>
        );
    }
}

export default Sectionclasse;
